import React, { act, useEffect, useState } from "react";
import CustomDialog from "../../components/common/CustomDialog";
import { CiSettings } from "react-icons/ci";
import * as Yup from "yup";
import { errorToast, successToast } from "../../utils/toasts";
import { Form, Formik } from "formik";
import CustomTextInput from "../../components/common/CustomTextInput";
import CustomButton from "../../components/common/CustomButton/CustomButton";
import { hideLoader, showLoader } from "../../utils/loader";
import { MdEmail, eye } from "react-icons/md";
import { EyeIcon } from "hugeicons-react";
import { EyeSlashIcon } from "@heroicons/react/16/solid";
import axios from "axios";
import { makeCredentialsRmUrl } from "../../utils/urls";

const validationSchema = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),

  password: Yup.string()
    .min(8, "Password must be at least 8 characters")
    .matches(/[a-z]/, "Must contain at least one lowercase letter")
    .matches(/[A-Z]/, "Must contain at least one uppercase letter")
    .matches(/[0-9]/, "Must contain at least one number")
    .required("Password is required"),

  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), null], "Passwords must match")
    .required("Confirm Password is required"),
});

function CreateCredentialsForRmModal({ relationship_manager_id, onClose }) {

  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const [isConfirmPasswordShow, setIsConfirmPasswordShow] = useState(false);

  useEffect(() => {
    console.log({ relationship_manager_id });
  }, [relationship_manager_id]);

  const handleSubmit = async (values, setSubmitting) => {
    try {
      showLoader();
      const makeCredentialsRmResponse = await axios.post(makeCredentialsRmUrl, {
        "relationship_manager_id": relationship_manager_id,
        "email": values.email,
        "password": values.password
      })
      if (makeCredentialsRmResponse?.data?.success) {
        console.log("Submitted Values", values);
        successToast("Credentials assigned successfully");
        onClose?.(true);
      } else {
        throw makeCredentialsRmResponse?.data;
      }
    } catch (err) {
      console.log(err?.response);
      errorToast(err?.response?.error?.message || "Failed to assign credentials");
    } finally {
      setSubmitting(false);
      hideLoader();
    }
  };

  return (
    <CustomDialog
      open={true}
      setOpen={() => {}}
      noTitleWrapper={true}
      className="mt-0"
      width={"70vw"}
      dontCloseOnOverlay={true}
      // height={"80vh"}
    >
      <div className="flex flex-col justify-between">
        <div className="flex w-full gap-2 items-center mb-4">
          <CiSettings className="text-lg" />
          <p className="text-black font-semibold">
            Create Credentials For Relationship Manager
          </p>
        </div>

        {/* Form */}
        <Formik
          initialValues={{
            email: "",
            password: "",
            confirmPassword: "",
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) =>
            handleSubmit(values, setSubmitting)
          }
        >
          {({ isValid, isSubmitting }) => (
            <div className="pt-4 flex-1 border-t border-[#E2EBF3]">
              <Form className="space-y-4">
                <div className="h-[calc(100vh_-_24rem)] overflow-y-auto">
                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                    <CustomTextInput
                      name="email"
                      label="Email"
                      placeholder="Enter Email"
                      endIcon={<MdEmail />}
                      required
                    />

                    <CustomTextInput
                      name="password"
                      label="Password"
                      placeholder="Enter Password"
                      type={isPasswordShow ? "text" : "password"}
                      endIcon={
                        isPasswordShow ? <EyeIcon className="w-5 h-5" /> : <EyeSlashIcon className="w-5 h-5" />
                      }
                      onEndIconClick={() => setIsPasswordShow(prev => !prev)}
                      required
                    />

                    <CustomTextInput
                      name="confirmPassword"
                      label="Confirm Password"
                      placeholder="Confirm Password"
                      type={isConfirmPasswordShow ? "text" : "password"}
                      endIcon={
                        isConfirmPasswordShow ? <EyeIcon className="w-5 h-5" /> : <EyeSlashIcon className="w-5 h-5" />
                      }
                      onEndIconClick={() => setIsConfirmPasswordShow(prev => !prev)}
                      required
                    />
                  </div>
                </div>

                {/* Buttons */}
                <div className="flex justify-between gap-4">
                  <CustomButton
                    type="button"
                    variant="outlined"
                    label="Close"
                    onClick={() => onClose?.(false)}
                  />
                  <CustomButton
                    type="submit"
                    label="Submit"
                    isLoading={isSubmitting}
                    disabled={!isValid}
                  />
                </div>
              </Form>
            </div>
          )}
        </Formik>
      </div>
    </CustomDialog>
  );
}

export default CreateCredentialsForRmModal;
